export default "__VITE_ASSET__lfT00OK___"